export default __webpack_public_path__ + "static/media/2411.9bf387bb.png";